import { render, staticRenderFns } from "./pedidos-mudancas-admin.vue?vue&type=template&id=61d6eb52&"
import script from "./pedidos-mudancas-admin.vue?vue&type=script&lang=js&"
export * from "./pedidos-mudancas-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports